import React from "react";
import LeftAndRightHeader from "../Sections/LeftAndRightHeader";
import LuxurySteps from "../Sections/LuxurySteps";
import "./LuxuryInsightsSection.css";


interface StepItem {
  id: number;
  title: string;
  text: string;
  curved?: boolean;
}

interface LuxuryInsightsProps {
  badge?:  React.ReactNode;
  badgeLabel?: string;
  leftTitle?: string;
  leftText?: string;
  rightText?: string;
  steps?: StepItem[];
}

export default function LuxuryInsightsSection({
  badge,
  badgeLabel,
  leftTitle,
  leftText,
  rightText,
  steps = [],
}: LuxuryInsightsProps) {
  return (
    <section className="luxury-insights">
      <div className="insights-header">
        <LeftAndRightHeader
          badge={badge}
          badgeLabel ={badgeLabel}
          leftTitle={leftTitle}
          leftText={leftText}
          rightText={rightText}
        />
      </div>

      <div className="insights-steps">
        <LuxurySteps steps={steps} />
      </div>
    </section>
  );
}
